import dayjs, { Dayjs } from "utils/dayjs"

import { Guid } from "@/types"

export enum OperationHoursSource {
    manual = "manual",
    inspection = "inspection",
    condition = "condition",
}

export interface IGetOperationHoursRecordDto {
    operationHours: number
    recordedOn: string
    recordedBy: Guid
    source?: OperationHoursSource | null
    inspectionId?: Guid | null
    shippingOrderId?: Guid | null
    reservationId?: Guid | null
}

export interface ICreateOperationHoursRecord {
    operationHours: number
    operationHoursTime?: Dayjs | null
}

export interface ICreateOperationHoursRecordDto {
    operationHours: number
    operationHoursTime?: string | null
}

export default class OperationHoursRecord {
    operationHours: number
    recordedOn: Dayjs
    recordedBy: Guid
    source?: OperationHoursSource
    inspectionId?: Guid
    shippingOrderId?: Guid
    reservationId?: Guid

    recordedByEmail?: string
    reservationNumber?: string

    constructor(dto: IGetOperationHoursRecordDto, {
        reservationNumber,
        recordedByEmail,
    }: {
        reservationNumber?: string
        recordedByEmail?: string
    } = {}) {
        this.operationHours = dto.operationHours
        this.recordedOn = dayjs(dto.recordedOn)
        this.recordedBy = dto.recordedBy
        this.source = dto.source || undefined
        this.inspectionId = dto.inspectionId || undefined
        this.shippingOrderId = dto.shippingOrderId || undefined
        this.reservationId = dto.reservationId || undefined

        this.reservationNumber = reservationNumber
        this.recordedByEmail = recordedByEmail
    }

    static getCreateDto(data: ICreateOperationHoursRecord): ICreateOperationHoursRecordDto {
        return {
            operationHours: data.operationHours,
            operationHoursTime: data.operationHoursTime
                ? dayjs(data.operationHoursTime).toISOString()
                : null,
        }
    }
}
